import { useState } from "react";
import { numberFormat } from "../../utils/helpers";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export const useWalletBalance = () => {
  const [showBalance, setShowBalance] = useState(false);
  const toggleBalance = () => setShowBalance(!showBalance);
  const displayAmount = (amount: any) =>
    showBalance ? numberFormat(parseInt(amount)) : "********";

  const icon = showBalance ? VisibilityOff : Visibility;

  return { displayAmount, toggleBalance, showBalance, icon };
};
